import { render, staticRenderFns } from "./Bajas.vue?vue&type=template&id=7b319467&"
import script from "./Bajas.vue?vue&type=script&lang=js&"
export * from "./Bajas.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports